import PropTypes from 'prop-types';

function MMGlutenFreeInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_1721_47839)">
                <path
                    d="M4.86127 12.5915C4.86127 12.5915 5.17788 14.303 7.60814 15.2314C10.0384 16.1599 11.1123 15.0603 11.1123 15.0603C10.7086 13.971 9.90551 13.0761 8.86605 12.5573C7.07759 11.7101 4.86127 12.5915 4.86127 12.5915Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.6925 8.78418C13.6925 8.78418 11.981 9.10508 11.0526 11.5353C10.1241 13.9656 11.2237 15.0395 11.2237 15.0395C12.314 14.6351 13.2091 13.8303 13.7267 12.789C14.5739 11.0005 13.6925 8.78418 13.6925 8.78418Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M6.52155 6.74695C6.52155 6.74695 14.407 25.5729 15.7591 27.5924C16.003 27.9475 17.5946 28.5251 17.4705 26.788C17.3978 25.8681 8.25011 5.98535 8.25011 5.98535L6.52155 6.74695Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.82 15.9375C16.82 15.9375 15.1085 16.2541 14.1801 18.6844C13.2174 21.1788 14.3512 22.1928 14.3512 22.1928C15.4415 21.7885 16.3366 20.9836 16.8542 19.9423C17.7014 18.1624 16.82 15.9375 16.82 15.9375Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.5126 3.6582C10.9992 3.65736 8.54187 4.40192 6.45158 5.79772C4.36128 7.19352 2.73186 9.17787 1.76941 11.4998C0.806951 13.8217 0.55469 16.3769 1.04453 18.8422C1.53437 21.3075 2.7443 23.5721 4.5213 25.3497C6.2983 27.1273 8.56255 28.338 11.0277 28.8287C13.4928 29.3194 16.0481 29.068 18.3703 28.1063C20.6926 27.1446 22.6774 25.5159 24.074 23.426C25.4705 21.3362 26.2158 18.8792 26.2158 16.3657C26.2158 12.9962 24.8776 9.76465 22.4954 7.38165C20.1132 4.99866 16.8821 3.65934 13.5126 3.6582ZM16.0327 14.5216C17.4704 13.3621 21.6805 9.32309 21.6805 9.32309C21.9158 9.60976 22.8486 10.8719 22.9299 11.0345C23.865 12.6819 24.3519 14.5456 24.3419 16.4399C24.332 18.3341 23.8255 20.1927 22.873 21.8301C21.9205 23.4675 20.5553 24.8265 18.9137 25.7716C17.272 26.7167 15.4112 27.2148 13.5169 27.2163C10.4192 27.2163 7.34288 25.4021 5.38755 23.3227C5.24208 23.173 9.16129 20.2122 9.16129 20.2122C9.16129 20.2122 14.3042 15.9378 16.0327 14.5216ZM4.10397 21.2904C3.29103 20.1908 2.67919 18.0172 2.67919 16.3657C2.68033 13.4932 3.8222 10.7388 5.85375 8.70805C7.88529 6.67731 10.6402 5.53652 13.5126 5.53652C15.9343 5.53652 18.3903 6.79871 19.9776 8.22776L4.10397 21.2904Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M3.03018 8.27013C3.03018 8.27013 3.35108 9.98158 5.78133 10.91C8.21158 11.8385 9.28552 10.7389 9.28552 10.7389C8.88114 9.64859 8.0763 8.75348 7.03496 8.2359C5.2465 7.38018 3.03018 8.27013 3.03018 8.27013Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.98889 19.7498C7.98889 19.7498 8.30551 21.4612 10.7358 22.394C13.166 23.3267 14.2399 22.2228 14.2399 22.2228C13.835 21.1318 13.0305 20.2355 11.9894 19.7156C10.2223 18.8727 7.98889 19.7498 7.98889 19.7498Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.8655 4.46191C11.8655 4.46191 10.154 4.78281 9.22127 7.21306C8.28853 9.64332 9.3967 10.7172 9.3967 10.7172C10.487 10.3129 11.3821 9.50804 11.8997 8.4667C12.7469 6.67824 11.8655 4.46191 11.8655 4.46191Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M5.43042 2.78125C5.43042 2.78125 4.55331 4.27877 5.78127 6.57638C7.00923 8.874 8.54953 8.73708 8.54953 8.73708C8.95497 7.64666 8.9305 6.44285 8.48108 5.36981C7.68097 3.56424 5.43042 2.78125 5.43042 2.78125Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.7222 19.7288C20.7222 19.7288 22.1342 18.719 21.9544 16.1219C21.7705 13.4563 20.3157 13.0156 20.3157 13.0156C19.499 13.8434 19.0278 14.9509 18.9979 16.1133C18.9894 18.0772 20.7222 19.7288 20.7222 19.7288Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.1765 22.5565C18.1765 22.5565 19.8879 22.7576 21.5095 20.7081C23.1311 18.6587 22.3652 17.3066 22.3652 17.3066C21.204 17.3735 20.1117 17.8798 19.3103 18.7229C17.9839 20.1819 18.1765 22.5565 18.1765 22.5565Z"
                    fill="#F2EBD1"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M21.0259 19.168L19.952 20.5542"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M20.8505 17.6874L20.4611 15.4668"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1721_47839">
                    <rect width="27.7126" height="31.3751" fill="white" transform="translate(0.484436 0.675781)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MMGlutenFreeInactive;

MMGlutenFreeInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

MMGlutenFreeInactive.defaultProps = {
    className: null,
    width: 28,
};
